import ToggleElement from './components/ToggleElement/ToggleElement';

import IframeYoutube from './components/IframeYoutube/IframeYoutube'
customElements.define('iframe-youtube', IframeYoutube)

import IframeVimeo from './components/IframeVimeo/IframeVimeo'
customElements.define('iframe-vimeo', IframeVimeo)

const catalogs = [...document.querySelectorAll('.c-catalogs-list__item-image')];

if(typeof (catalogs) !== 'undefined'){
  setCatalogImageHeights();
  window.addEventListener("resize", function () {
    setCatalogImageHeights();
  });
  function setCatalogImageHeights(){

    for (let item of catalogs) {

      let width = item.offsetWidth;

      item.style.height = width + 'px';
    }
  }
}

const ToggleTriggers = [...document.querySelectorAll('.toggle-trigger')]
for (let trigger of ToggleTriggers) {
  new ToggleElement(trigger)
}
import HeaderScroll from './components/HeaderScroll/HeaderScroll';
HeaderScroll()


import {FormDynamic} from './components/FormDynamic/FormDynamic'
FormDynamic()


const actionsSubmit = [...document.querySelectorAll('.action--submit')];

actionsSubmit.forEach(action => {
  action.addEventListener('click', evt => {
    action.classList.add('action--submit-loading')
  }, false)
})


import {FieldFocus} from "./components/FieldFocus/FieldFocus"
FieldFocus()

document.addEventListener('freeform-ready', (event) => {
  // scrolling offset in pixels from the top of the form.
  // defaults to 0
  event.options.scrollOffset = -200;
});




